const sectionEditFormButtons = {
    save: 'SAVE CHANGES',
    cancel: 'BACK'
};

export default sectionEditFormButtons;